module.exports = __webpack_public_path__ + "img/26.c343d0e9.webp";